import React, { useState } from 'react';
import { ChevronDown, HelpCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const FAQ = () => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: t('faq.q1'),
      answer: t('faq.a1')
    },
    {
      question: t('faq.q2'),
      answer: t('faq.a2')
    },
    {
      question: t('faq.q3'),
      answer: t('faq.a3')
    },
    {
      question: t('faq.q4'),
      answer: t('faq.a4')
    },
    {
      question: t('faq.q5'),
      answer: t('faq.a5')
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq-section-modern">
      <div className="faq-container-modern">
        <div className="faq-header-modern">
          <div className="faq-icon-wrapper">
            <HelpCircle size={32} />
          </div>
          <h2 className="faq-title-modern">{t('faq.title')}</h2>
          <p className="faq-subtitle-modern">{t('faq.subtitle')}</p>
        </div>
        
        <div className="faq-grid-modern">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`faq-card-modern ${openIndex === index ? 'faq-card-open' : ''}`}
            >
              <button 
                className="faq-question-modern"
                onClick={() => toggleFAQ(index)}
                data-testid={`faq-question-${index}`}
              >
                <span className="faq-number">{String(index + 1).padStart(2, '0')}</span>
                <span className="faq-question-text">{faq.question}</span>
                <ChevronDown 
                  size={20} 
                  className={`faq-chevron ${openIndex === index ? 'faq-chevron-open' : ''}`}
                />
              </button>
              <div className={`faq-answer-modern ${openIndex === index ? 'faq-answer-visible' : ''}`}>
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
